// /src/store/paymentManagment/reducer.ts

import {
  FETCH_PAYMENTS_REQUEST,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAILURE,
  FETCH_PAYMENT_BY_ID_REQUEST,
  FETCH_PAYMENT_BY_ID_SUCCESS,
  FETCH_PAYMENT_BY_ID_FAILURE,
  PaymentState,
  initialPaymentState,
  PaymentActionTypes
} from './types';

// Réducteur pour les paiements
export const paymentListReducer = (state = initialPaymentState, action: PaymentActionTypes): PaymentState => {
  switch (action.type) {
    case FETCH_PAYMENTS_REQUEST:
    case FETCH_PAYMENT_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PAYMENTS_SUCCESS: {
      const paymentsMap = new Map(state.payments);
      action.payload.payments.forEach(payment => {
        paymentsMap.set(payment.id, payment);
      });
      return {
        ...state,
        loading: false,
        payments: paymentsMap,
        lastFetchTimestamp: action.payload.lastFetchTimestamp,
        lastFetchParams: action.payload.lastFetchParams
      };
    }

    case FETCH_PAYMENT_BY_ID_SUCCESS: {
      const paymentsMap = new Map(state.payments);
      paymentsMap.set(action.payload.id, action.payload);
      return {
        ...state,
        loading: false,
        payments: paymentsMap,
        lastFetchTimestamp: Date.now()
      };
    }

    case FETCH_PAYMENTS_FAILURE:
    case FETCH_PAYMENT_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default paymentListReducer;
